import React from "react";
import { Container, Grid } from "@mui/material";
import styled from "@emotion/styled";
import SectionsHeading from "../../SectionsHeading";
import Paragraph from "../../Paragraph";
import { FlexDiv, Image } from "../../../Styles/style";
const ContinerWraper = styled(Container)`
  width: 100%;
  padding: 0 !important;
  background-image: url("./Images/contact.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`;
const FooterWraper = styled(Container)`
  width: 100%;
  padding: 20px 0 !important;
`;

const GridWraper = styled(Grid)`
  width: 100%;
  padding: 80px 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const PageWraper = styled.div`
  background: #050C24;
`;
const Div = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  @media (max-width: 599px) {
    flex-direction: column;
  }
`;
const ColorDiv = styled.div`
  width: 100%;
  height: 100%;
  background: #070f29e3;
`;
const CustomDiv = styled.div`
    background: ${props => props.bgc ? props.bgc : "linear-gradient(to top, #050C24, #2A355D)"};
    width: 80%;
    text-align: center;
    padding: 2%;
    font-size: 12px;
    border-radius: 20px;
    font-family: ${props=> props.fm ? props.fm : "PoppinsSB"};
    margin:  0 5px;
    color:#fff;
    border: ${props => props.b ? props.b : "none"};
    box-shadow: ${props => props.bs ? props.bs : "inset 1px 3px 3px #406BFF"};
    transition: .5s;
    text-transform: none;
    z-index: 1;
    :hover{
      background: #406BFF;
      box-shadow: none;
    }
    @media(max-width:599px){
      font-size: ${props=> props.fs599};
  }

`

const InTouchSection = () => {
  return (
    <PageWraper id="home">
      <ContinerWraper maxWidth="xxl">
        <ColorDiv>
          <Container sx={{}}>
            <GridWraper container>
              <Grid
                item
                xs={10}
                sm={6}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {/* <AbsoluteImage w="100%" src='./Images/conatactimage.png'/> */}
                <SectionsHeading ta="center" data-aos="zoom-in">Contact Us</SectionsHeading>
                {/* <Paragraph ta="center" m="0 0 10px">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr.
              </Paragraph> */}
                <CustomDiv data-aos="fade-up">
                  info@moonracer.finance
                </CustomDiv>
              </Grid>
            </GridWraper>
          </Container>
        </ColorDiv>
      </ContinerWraper>
      <FooterWraper maxWidth="xxl">
        <Container>
          <Div>
            <Paragraph ta="center" fs="14px">
              © 2023 Moon Racer on the ERC20. All rights reserved.
            </Paragraph>
            <FlexDiv w="none" p="0">
              <a href="https://t.me/moonracerfinance" target="blank">
                <Image w599="30px" src="./Images/telegram.png" />
              </a>
              <a href="https://twitter.com/moonracercoin" target="blank">
                <Image w599="30px" src="./Images/twiter.png" />
              </a>
            </FlexDiv>
          </Div>
        </Container>
      </FooterWraper>
    </PageWraper>
  );
};

export default InTouchSection;
